import { create } from 'zustand';

import { AppData, Consumer } from 'mediasoup-client/lib/types';

type TConsumer = Promise<Consumer<AppData>>;

interface IConsumersStore {
  // Consumers
  consumers: Map<string, TConsumer>;
  appendConsumer: (id: string, consumer: TConsumer) => void;
  deleteConsumer: (id: string) => void;

  // AudioConsumers
  audioConsumers: Map<string, string>;
  appendAudioConsumer: (audioConsumerId: string, id: string) => void;
  deleteAudioConsumer: (audioConsumerId: string) => void;
  resetStates: () => void;
}

export const useConsumersStore = create<IConsumersStore>((set) => ({
  consumers: new Map(),
  appendConsumer: (id, consumer) =>
    set((state) => {
      const updatedConsumers = new Map(state.consumers);
      updatedConsumers.set(id, consumer);
      return { ...state, consumers: updatedConsumers };
    }),
  deleteConsumer: (id) =>
    set((state) => {
      const updatedConsumers = new Map(state.consumers);
      updatedConsumers.delete(id);

      return { ...state, consumers: updatedConsumers };
    }),
  // AudioConsumers
  audioConsumers: new Map(),
  appendAudioConsumer: (audioConsumerId, id) =>
    set((state) => {
      const updatedAudioConsumers = new Map(state.audioConsumers);
      updatedAudioConsumers.set(audioConsumerId, id);
      return { ...state, audioConsumers: updatedAudioConsumers };
    }),
  deleteAudioConsumer: (audioConsumerId) =>
    set((state) => {
      const updatedAudioConsumers = new Map(state.consumers);
      updatedAudioConsumers.delete(audioConsumerId);

      return { ...state, consumers: updatedAudioConsumers };
    }),
  resetStates: () => set({ consumers: new Map(), audioConsumers: new Map() }),
}));
